import React from 'react'
import { useThemeUI } from 'theme-ui'
import { toCamelCase } from '../../utils/string'
import sw from '../../utils/switch'
import loadable from '@loadable/component'
import getComponentVariants from '../helpers/get-component-variants'
import withComponentBase from '../helpers/with-component-base'

const ImageTextModule = loadable(() => import('./image-text'))

const leftColorBlock = {
  left: ['-xs', '-xxxl'],
  top: ['-xs', 'xxxl'],
}

const rightColorBlock = {
  left: ['-xs', 'xxxl'],
  top: ['-xs', '-sm'],
}

const ImageTextCalloutModule = ({ layout, ...props }) => {
  const { theme } = useThemeUI()
  const variant = toCamelCase(layout)
  const styles = getComponentVariants(theme, 'modules', 'image-callout', [variant])
  const blockColor = styles('colorBlock')

  return sw({
    solidColorImageLeft: () => (
      <ImageTextModule
        layoutDirection='left'
        layout='image text'
        colorBlock={{
          ...leftColorBlock,
          ...blockColor,
        }}
        {...props}
      />
    ),
    solidColorImageRight: () => (
      <ImageTextModule
        layoutDirection='right'
        layout='text image'
        colorBlock={{
          ...rightColorBlock,
          ...blockColor,
        }}
        {...props}
      />
    ),
    imageLeft: () => <ImageTextModule layoutDirection='left' layout='image text' {...props} />,
    imageRight: () => <ImageTextModule layoutDirection='right' layout='text image' {...props} />,
    default: null,
  })(variant)
}

export default withComponentBase(ImageTextCalloutModule, {
  withHeaderFooter: true,
  wrapHeaderFooterChildren: true,
  headerStyles: {
    textAlign: 'center',
    mt: 'lg',
  },
  footerStyles: {
    textAlign: 'center',
  },
})
